import { CategoryTree } from '@/lib/graphql/generated/graphql';

// Fonction pour formater le texte d'affichage des catégories
export const formatCategoryText = (text: string): string => {
  return text.includes(' > ')
    ? `${text.split(' - ')[0]} - ${text.split(' > ').reverse()[0]}`
    : text;
};

// Fonction pour trouver une catégorie par son ID dans l'arbre
export const findCategoryById = (
  categories: CategoryTree[],
  id: string
): CategoryTree | null => {
  for (const category of categories) {
    if (category.id === id) return category;
    if (category.subCategories) {
      const found = findCategoryById(category.subCategories, id);
      if (found) return found;
    }
  }
  return null;
};

// Fonction pour vérifier si une catégorie correspond à la recherche
export const matchesSearch = (cat: CategoryTree, query: string): boolean => {
  if (!query) return true;

  const labelMatches = cat.label.toLowerCase().includes(query.toLowerCase());
  const idMatches = cat.id.toLowerCase().includes(query.toLowerCase());
  const subCategoriesMatch =
    cat.subCategories?.some((subCat) => matchesSearch(subCat, query)) || false;

  return labelMatches || idMatches || subCategoriesMatch;
};
